interface BoardQuickStatsProps {
  jobsQueued: number | null;
  unitsAvailable: number | null;
}

/** The two numbers a dispatcher scans first. Each is the same figure the panel below shows (the queue's total, the strip's Available), so they cannot disagree. */
export function BoardQuickStats({ jobsQueued, unitsAvailable }: BoardQuickStatsProps) {
  return (
    <dl className="flex gap-6 text-sm">
      <Stat label="Jobs queued" value={jobsQueued} />
      <Stat label="Units available" value={unitsAvailable} />
    </dl>
  );
}

function Stat({ label, value }: { label: string; value: number | null }) {
  return (
    <div className="flex items-baseline gap-2">
      <dd className="order-first text-2xl font-semibold text-fg">{value ?? '—'}</dd>
      <dt className="text-muted">{label}</dt>
    </div>
  );
}
